import {
  useLocalStorageState as aHookUseLocalStorageState,
  useSessionStorageState,
} from 'ahooks';
import { Dispatch, SetStateAction } from 'react';

/**
 * Storage 的封装
 * 参数一 LocalStorage key
 * 参数一 defaultValue 默认值
 */

type IProps<T> = {
  key: string;
  defaultValue?: T;
};
// string
export const useStrignStorage: any = <T = any>({
  key,
  defaultValue,
}: IProps<T>) => {
  return aHookUseLocalStorageState<any>(key, {
    serializer: (v) => v ?? '',
    deserializer: (v) => v,
    defaultValue: defaultValue ?? '',
  });
};
//使用LocalStorage缓存状态
export const useLocalStorage = <T = any>({ key, defaultValue }: IProps<T>) => {
  return aHookUseLocalStorageState(key, {
    defaultValue: defaultValue ?? null,
  }) as [T, Dispatch<SetStateAction<T>>];
};
//使用SessionStorage缓存状态
export const useSessionStorage = <T = any>({
  key,
  defaultValue,
}: IProps<T>) => {
  return useSessionStorageState(key, {
    defaultValue: defaultValue ?? null,
  }) as [T, Dispatch<SetStateAction<T>>];
};
